export function isValidEmail(email) {
  const EMAIL_REGEX_RFC_5322 = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return EMAIL_REGEX_RFC_5322.test(email);
}

export function isValidPhone(phoneDigits) {
  return phoneDigits.length === 10;
}
